export default {
  application: {
    name: "CPFL - Dashboard",
    shortDescription: "CPFL Total",
    title: "CPFL Total Dashboard",
    version: {
      title: "Versão",
      number: "1.0.0",
    },
    footer: {
      poweredBy: "Powered by",
      poweredByBrand: "MB Labs",
      poweredByBrandUrl: "https://mblabs.com.br",
    },
    currency: "R$",
    percent: "%",
    error: {
      networkMessage: "Network Error",
      network: "O servidor se encontra com problemas, tente mais tarde!",
      default: "Ocorreu um erro! Tente novamente mais tarde",
      defaultForm: "Ocorreu um erro! Verifique seus dados e tente novamente!",
    },
  },
  routes: {
    error: {
      pageTitle: "Erro",
    },
    passwordRecovery: {
      pageTitle: "Recuperação de senha",
      url: "/passwordRecovery/1",
      messages: {
        recoveryEmailSent:
          "Você receberá um e-mail de recuperação de senha no e-mail informado",
      },
      parent: "Início",
      errors: {
        fields: "Preencha o campo para recuperar sua senha",
        network:
          "Houve um erro ao contato o servidor, tente novamente mais tarde",
        invalid: "Preencha um documento válido",
      },
      content: {
        title: "Recuperação de Senha",
        subtitle: "Preencha dos dados abaixo para continuar.",
        step: "PASSO 1/3",
      },
      form: {
        documentLabel: "CPF",
        documentPlaceholder: "Insira o seu documento aqui",
      },
    },
    passwordRecoveryMode: {
      pageTitle: "Recuperação de senha",
      url: "/passwordRecovery/2",
      parent: "Início",
      content: {
        title: "Recuperação de Senha",
        subtitle: "Preencha os dados abaixo para continuar",
        step: "PASSO 2/3",
        radioLabel: "Enviaremos o token para:",
      },
    },
    passwordRecoveryCode: {
      pageTitle: "Recuperação de senha",
      url: "/passwordRecovery/3",
      parent: "Início",
      content: {
        title: "Recuperação de senha",
        subtitle: "Preencha os dados abaixo para continuar",
        step: "PASSO 3/3",
      },
      form: {
        tokenLabel: "Token recebido",
        tokenPlaceholder: "Insira o token recebido",
        passwordLabel: "Senha",
        passwordPlaceholder: "Insira a sua nova senha aqui",
        passConfirmationLabel: "Confirmar Senha",
        passConfirmationPlaceholder: "Confirme sua nova senha aqui",
      },
      errors: {
        generic: "Houve um erro, tente novamente",
        unmatch: "As senhas não conferem",
        tooshort: "a senha precisa ter mais que 6 caracteres",
        filled: "Por favor, preencha todos os campos",
      },
      messages: {
        success: "Sua senha foi alterada com sucesso!",
      },
    },
    reportDownloads: {
      pageTitle: "Central de downloads",
      url: "/report-downloads",
      title: "Central de downloads",
      subtitle: "Gerencie os dados exportados do CPFL Marketplace",
      content: {},
    },
    distributor: {
      pageTitle: "Distribuidoras",
      url: "/distributor",
      content: {},
    },
    distributorDetail: {
      pageTitle: "Distribuidoras",
      url: "/distributor/:id",
      content: {},
    },
    login: {
      pageTitle: "Login",
      url: "/",
      messages: {
        welcome: "Seja bem vindo!",
      },
      errors: {
        fields: "Preencha os campos para efetuar o login",
        credentials: "Documento ou senha inválidos",
        serverError:
          "Houve um error ao contatar o servidor, tente novamente mais tarde.",
      },
      content: {
        title:
          "Negocie seu débito sem sair de casa e quite suas faturas de energia.",
        subtitle:
          "Você pode simular o seu parcelamento quantas vezes quiser e realizar o parcelamento sem burocracia.",
        hello: "Olá,",
        greetings:
          "bem-vindo, precisamos dos dados abaixo para continuar o acesso.",
        documentLabel: "CPF ou CNPJ",
        documentPlaceholder: "427.274.217-24",
        passwordLabel: "Senha",
        loginButton: "CONTINUAR",
        forgetPassword: "esqueci minha senha",
        firstAccess: "Primeiro acesso?",
        registerHere: " e cadastre-se",
        needHelp: "Precisa de ajuda?",
        helpChannel: " e tire suas dúvidas",
        clickHere: "Clique aqui",
      },
      form: {
        documentLabel: "CPF ou CNPJ",
        documentPlaceholder: "Insira o seu cpf aqui",
        passwordLabel: "Senha",
        passwordPlaceholder: "Insira a sua senha aqui",
        passConfirmLabel: "Confirmar Senha",
        passConfirmPlaceholder: "Confirme a sua senha aqui",
      },
    },
    partnerDetail: {
      pageTitle: "Detalhe de parceiro",
      url: "/partner/:id",
      content: {},
    },
    userPartner: {
      pageTitle: "Usuários",
      url: "/userPartner",
      content: {},
    },
    userPartnerDetail: {
      pageTitle: "Detalhe de usuário financeira",
      url: "/userPartner/:id",
      content: {},
    },
    clientsBlockList: {
      pageTitle: "Usuários BlockList",
      url: "/block-list/users",
      content: {},
    },
    clientBlockListForm: {
      pageTitle: "Detalhe do cliente BlockList",
      url: "/block-list/users/:id",
      content: {},
      register_title: "Cadastro clientes BlockList",
      register_subtitle: "Veja os detalhes e edite a BlockList",
      tittle: "Block List - Usuários",
      subtitle: "Gerencie a Block List do CPFL Marketplace",
      errors: {
        error: "ERROS",
        success: "SUCESSO",
        imported: "LINHAS IMPORTADAS",
        description_error: "DESCRIÇÃO ERROS",
        emptyColumn: "Células vazias",
        invalidDocument: "Documento inválido",
        documentAlreadyExists: "Documento já existente",
      },
    },
    citiesBlockList: {
      pageTitle: "Cidades BlockList",
      url: "/block-list/cities",
      content: {},
    },
    cityBlockListForm: {
      pageTitle: "Detalhe da cidade BlockList",
      url: "/block-list/cities/:id",
      content: {},
      register_title: "Cadastro cidades BlockList",
      register_subtitle: "Veja os detalhes e edite a BlockList",
      tittle: "Block List - Cidades",
      subtitle: "Gerencie a Block List do CPFL Marketplace",
      errors: {
        error: "ERROS",
        success: "SUCESSO",
        imported: "LINHAS IMPORTADAS",
        description_error: "DESCRIÇÃO ERROS",
        emptyColumn: "Células vazias",
        stateCityAlreadyBlocked: "Estado/Cidade ja bloqueado",
      },
    },
    preContract: {
      pageTitle: "Pré-Contratos",
      url: "/pre-contract",
      content: {},
    },
    preContractDetail: {
      pageTitle: "Detalhes do cliente",
      url: "/pre-contract/:id/:idPrecontract",
      content: {
        title: "Detalhes do cliente",
        subtitle: "Veja os detalhes do cliente",
      },
    },
    preContractConsolidated: {
      pageTitle: "Pré-Contratos Consolidados",
      url: "/consolidated/pre-contract",
      content: {},
    },
    contractConsolidated: {
      pageTitle: "Contratos Fechados",
      url: "/consolidated/contract",
      content: {},
    },
    installment: {
      pageTitle: "Parcelas",
      url: "/installment",
      content: {},
    },
    contract: {
      pageTitle: "Contratos",
      url: "/contract",
      content: {},
    },
    billet: {
      pageTitle: "Boletos",
      url: "/billet",
      content: {
        title: "Boletos",
        subtitle: "Gerencie os Boletos do CPFL Marketplace",
        currentMonth: "Mês Atual",
        currentWeek: "Semana Atual",
        lastWeek: "Semana Anterior",
      },
      errors: {
        error: "ERROS",
        success: "SUCESSO",
        imported: "LINHAS IMPORTADAS",
        description_error: "DESCRIÇÃO ERROS",
        billetAlreadyMapped: "Boleto já Emitido",
        emptyColumn: "Células vazias",
      },
    },
    payment: {
      pageTitle: "Pagamentos",
      url: "/payment",
      content: {
        title: "Pagamentos",
        subtitle: "Gerencie os pagamentos feitos por clientes",
        tabs: {
          totalHistory: "Histórico Total",
          allCollections: "Todas as arrecadações",
          settlementHistory: "Histórico de quitação",
          materaSettlementHistory: "Histórico Total",
        },
        table: {
          date: "Data",
          processedCollections: "Total de linhas do arquivo",
          success: "Sucesso na arrecadação",
          errors: "Erros na arrecadação",
          approver: "Aprovador",
        },
        materaSettlementHistory: {
          processDate: "Data",
          success: "Sucesso na arrecadação",
          errors: "Erros na arrecadação",
          approvedBy: "Aprovador",
          origin: "Origem",
        },
      },
    },
    invoiceCompensation: {
      pageTitle: "Compensação de faturas",
      url: "/payment/invoice-compensation",
      content: {
        title: "Compensação de faturas",
        subtitle:
          "Gerencie a compensação de faturas relacionadas aos contratos",
        averageDaysTitle: "Média de dias para compensação",
        averageDaysSuffix: "dias",
        averageDaysDescription:
          "Intervalo médio de tempo entre a assinatura de contrato e a baixa das faturas relacionadas.",
        table: {
          date: "Data",
          compensatedInvoices: "Faturas compensadas",
          compensationValidation: "Validação de compensação",
        },
      },
    },
    receivablesAnticipation: {
      pageTitle: "Antecipação de Recebíveis",
      url: "/contract/receivables-anticipation",
      content: {
        title: "Antecipação de Recebíveis",
        subtitle: "Gerencie a antecipação de recebíveis",
      },
    },
    storagePayment: {
      errors: {
        error: "ERROS",
        success: "SUCESSO",
        imported: "LINHAS IMPORTADAS",
        totalRecords: "Total de registros",
      },
    },
    installmentExpire: {
      pageTitle: "Parcelas Vencidas",
      url: "/installment/expire",
      content: {},
    },
    installmentPending: {
      pageTitle: "Parcelas Abertas",
      url: "/installment/pending",
      content: {},
    },
    installmentPaid: {
      pageTitle: "Parcelas Pagas",
      url: "/installment/paid",
      content: {},
    },
    client: {
      pageTitle: "Clientes",
      url: "/client",
      content: {},
    },
    clientDetail: {
      pageTitle: "Detalhe de cliente",
      url: "/client/:id",
      content: {},
    },
    clientNewComplaint: {
      pageTitle: "Cadastro de reclamação",
      url: "/client/:id/complaint/new",
      content: {},
    },
    clientEditComplaint: {
      pageTitle: "Edição de reclamação",
      url: "/client/:id/complaint/:complaintId/edit",
      content: {},
    },
    hashAgencyClient: {
      pageTitle: "Agência Virtual",
      url: "/hash-agency",
      content: {},
    },
    contractDetail: {
      pageTitle: "Dados do contrato",
      url: "/contract/:id",
      content: {
        title: "Contrato",
        status: "Status",
        subtitle: "Veja os detalhes de contrato",
        emptyState: "Você não possui nenhum contrato de empréstimo aberto",
        outstandingBalance: "Saldo devedor",
        totalAmount: "Valor Total do Contrato",
        totalInstallments: "Nº de parcelas",
        contractDate: "Data do contrato",
        downloadContract: "BAIXAR CONTRATO",
        protectionInsurance: "Status Seguro",
      },
    },
  },
  cancelInstallments: {
    error: "Erro ao cancelar parcelas",
  },

  components: {
    backButton: "VOLTAR",
    nextButton: "AVANÇAR",
    simulate: "SIMULAR EMPRÉSTIMO",
    agree: "CONCORDO",
    send: "ENVIAR",
    sider: {
      hello: "Olá, ",
      personalCode: "Seu Código: ",
      totalBillings: "Valor Total de Contas Abertas",
      menu: {
        home: "Início",
        contracts: "Meus contratos",
        invoices: "Minhas faturas",
      },
    },
    advancedCard: {
      balanceDue: "Saldo devedor",
      institution: "Financiadora",
      contract: "CONTRATO",
      totalContract: "VALOR TOTAL DO CONTRATO",
      numberOfBillings: "Nº DE PARCELAS",
      contractDate: "DATA DO CONTRATO",
      details: "DETALHES",
      currency: "R$ ",
      status: "STATUS",
    },
    invoiceTable: {
      header: {
        number: "Fatura",
        referringMonth: "Mês ref.",
        description: "Descrição da fatura",
        dueDate: "Vencimento",
        totalAmount: "Valor",
      },
    },
    addressPicker: {
      addressSelected: "Endereço selecionado",
      totalAmount: "Total à pagar: ",
    },
    userDropdown: {
      installationNumber: "NÚMERO DE INSTALAÇÃO",
      situation: "SITUAÇÃO",
      owner: "TITULAR DA CONTA",
      changeMyData: "Alterar meus dados",
      FAQ: "Dúvidas frequentes",
      settings: "Configuração da conta",
      logout: "Sair",
    },
    contractTable: {
      header: {
        number: "Parcelas",
        referenceMonth: "Mês ref.",
        source: "Origem da cobrança",
        dueDate: "Vencimento",
        totalAmount: "Valor",
        status: "Status",
      },
    },
  },

  success: {
    CREATED: "Inserido com sucesso!",
    UPDATED: "Atualizado com sucesso!",
    REQUEST_EXPORT_DATA:
      "Sua solicitação foi enviada para processamento e em breve você será notificado por email.",
  },

  errors: {
    DATE_FILTER_ERROR: "Selecione uma data inicial e final para a exportação",
    DATE_FILTER_PERIOD_INVALID:
      "Só é possível exportar entre um período máximo de 6 meses",
    CLIENT_DATE_FILTER_PERIOD_INVALID:
      "Só é possível exportar entre um período máximo de 1 mês",
    USER_NOT_FOUND: "Cliente não encontrado",
    INVALID_SCHEMA: "O esquema informado é inválido",
    INVALID_PARAMETER: "O parâmetro informado é inválido",
    INVALID_ID: "O identificador informado é inválido",
    INVALID_NAME: "O nome informado é inválido",
    INVALID_EMAIL: "O email informado é inválido",
    INVALID_PASSWORD: "A senha informada é inválida",
    INVALID_CREDENTIALS: "E-mail ou senha inválida",
    INVALID_RECAPTCHA: "O recaptcha informado é inválido",
    INVALID_DOCUMENT: "Documento inválido",
    UNAUTHORIZED: "Não autorizado",
    TOKEN_EXPIRED: "O token foi expirado",
    NOT_FOUND: "Não foi possível encontrar",
    INVALID_PAGE: "A página é inválida",
    SOMETHING_WENT_WRONG: "Algo de errado aconteceu",
    DOCUMENT_ALREADY_USED: "O documento já esta sendo utilizado",
    NAME_ALREADY_USED: "O nome já esta sendo utilizado",
    INSTALLATION_NOT_FOUND: "Instalação não encontrada",
    GENERIC: "Houve um erro, tente novamente ou volte mais tarde",
    OracleException: "Houve um erro, tente novamente ou volte mais tarde",
    TaskCanceledException: "Houve um erro, tente novamente ou volte mais tarde",
    CommunicationException: "Houve um erro com o GMP",
    INSTALLATION_ALREADY_EXISTS: "Essa instalação já foi adicionada",
    NETWORK:
      "Houve um problema com a rede, verifique sua conexão ou tente novamente mais tarde",
    BACKOFFICE_USER_ALREADY_EXISTS: "Usuário já está cadastrado",
    BACKOFFICE_USER_NOT_FOUND: "Cliente não encontrado",
    CANNOT_BE_EMPTY: "Preencha o(s) campo vazio",
    BACKOFFICE_CLIENT_ALREADY_EXISTS_BLOCK_LIST:
      "Cliente já cadastrado na lista de bloqueio",
    BACKOFFICE_CITIES_ALREADY_EXISTS_BLOCK_LIST:
      "Cidade já cadastrada na lista de bloqueio",
    CLIENT_IS_NOT_FOUND_BLOCK_LIST: "Cliente não encontrado",
    INVALID_DDD_NUMBER: "Número do DDD do telefone inválido!",
    PERMISSION_DENIED: "Usuário sem permissão",
    ALL_SELECTED_INSTALLMENTS_ALREADY_INVOICED:
      "Todas as Parcelas ja faturadas",
    BusinessException: "Houve um erro, tente novamente ou volte mais tarde",
    HAS_INSTALLMENTS_ALREADY_INVOICED: "Existe parcela(s) ja faturada(s).",
    DUE_DATE_IN_PAST: "Data de vencimento nao pode ser no passado",
    CONTRACT_NOT_FOUND: "Contrato não encontrado",
    CLIENT_IS_BLOCK_LIST: "Usuário em Block-List CPFL",
    CONTRACT_CANCELLED: "Contrato cancelado",
    EMAIL_MISMATCH_KOBANA: "E-mail inconsistente com o registro na Kobana.",
    USER_NOT_FOUND_KOBANA: "Usuário não localizado na plataforma Kobana.",
    COMMUNICATION_ERROR_KOBANA: "Erro de comunicação com Kobana.",
    CLIENT_ALREADY_REGISTERED_KOBANA: "Cliente já cadastrado na Kobana.",
    FAILED_TO_FETCH_AMOUNT:
      "Falha ao buscar o valor da quitação. Insira o valor manualmente.",
  },
  enum: {
    profileType: {
      admin: "Administrador",
      user: "Usuário",
    },
  },
};
